import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NbAccordionModule, NbButtonModule, NbCardModule } from '@nebular/theme';
import { ApprovalComponent } from './approval.component';
import { ApprovalDetailsModule } from '../approval-details/approval-details.module';


@NgModule({
    declarations: [ApprovalComponent],
    imports: [
        CommonModule,
        NbButtonModule,
        FlexLayoutModule,
        NbAccordionModule,
        NbCardModule,
        ApprovalDetailsModule
    ],
    exports: [ApprovalComponent]
})
export class ApprovalModule { }
